export default __webpack_public_path__ + "static/outsource@mob_2x-452410c39c92af854989d0c369076fed.png";